/* global femcare */

femcare.sampleCoupon.order = {
    $samples: $('.sample-coupon'),

    init: function () {
        if (this.$samples.length) {
            this.initFragmentListener();
            this.initOrderToggleHandlers();
            this.initUrlQueryListener();

            if (typeof dataLayer !== 'undefined') {
                this.initGaEventsOnClick();
            }
        }
    },

    initOrderToggleHandlers: function () {
        this.$samples.find('.signpost-basic a').on('click', this.loadOrderForm.bind(this));

        // Close opened order on close button click.
        $('.sample-coupon__order').on(
            'click',
            '.sample-coupon__close, .sample-coupon-response__ok',
            $.proxy(function (e) {
                e.preventDefault();
                this.closeOrderForm($(e.currentTarget).closest('.sample-coupon__order'));
            }, this)
        );
    },

    loadOrderForm: function (e) {
        e.preventDefault();

        var $button = $(e.currentTarget);
        var $sample = $button.closest('.sample-coupon');
        var $orderToOpen = $sample.find('.sample-coupon__order');

        // Close any other order that is opened before opening the new one.
        var $orderToClose = $('.sample-coupon__order')
            .not($orderToOpen)
            .filter(':parent');

        var requestInfo = { method: 'get', uri: $sample.data('ajax-uri') };

        if ($orderToClose.length) {
            this.closeOrderForm(
                $orderToClose,
                $.proxy(function () {
                    this.makeRequest(requestInfo, $orderToOpen);
                }, this)
            );
        } else {
            this.makeRequest(requestInfo, $orderToOpen);
        }
    },

    makeRequest: function (requestInfo, $order) {
        var data = requestInfo.method === 'post' ? $order.find('form').serialize() : null;

        $.ajax({
            type: requestInfo.method,
            url: requestInfo.uri,
            data: data,
            cache: false,
            success: $.proxy(function (response) {
                if (response.type === 'HTML') {
                    $order.html(response.content);
                    var $form = $order.find('form');
                    if ($form.length) {
                        this.initOrderForm($form);
                    }

                    $order.slideDown();
                    var scrollTop = $order.offset().top;

                    $('html, body').animate({ scrollTop: scrollTop }, 1000);
                } else if (response.type === 'Location') {
                    window.location = response.content;
                }
            }, this)
        });
    },

    /**
     * Initialize coupon form.
     * @param {object} $form jQuery form object to be initialized
     */
    initOrderForm: function ($form) {
        var $order = $form.closest('.sample-coupon__order');
        var $sample = $order.closest('.sample-coupon');

        var title = $sample.find('.signpost-basic__headline').text();
        var body = $sample.find('.signpost-basic__body').html();

        $order
            .find('h3')
            .text(title)
            .after(body);

        if ($form.find('#dynamicRecaptcha').length) {
            femcare.form.recaptcha.initDynamicRecaptcha();
        }

        femcare.shared.inputs.initInputsForForm($form);
        femcare.form.validation.initFormValidation($form);

        $form.on('submit',
            $.proxy(function (e) {
                e.preventDefault();
                var $submit = $form.find('button[type="submit"]');
                $submit.prop('disabled', true);

                var requestInfo = { method: 'post', uri: $sample.data('ajax-uri') };

                this.makeRequest(requestInfo, $order);
            }, this)
        );
    },

    /**
     * Close sample order.
     * @param {object} $orderToClose sample order to be closed.
     * @param {function} callback function to be called after close.
     */
    closeOrderForm: function ($orderToClose, callback) {
        $orderToClose.slideUp(300, function () {
            $orderToClose.empty();
            if (callback) {
                callback();
            }
        });
    },

    initFragmentListener: function () {
        var fragment = window.location.hash;

        if (fragment) {
            var $sample = $(fragment);

            if ($sample.length) {
                var isSampleUnavailable = !!$sample.find('.signpost-basic__call-to-action--unavailable').length;

                if (isSampleUnavailable) {
                    return;
                }

                var $orderToOpen = $sample.find('.sample-coupon__order');
                var requestInfo = { method: 'get', uri: $sample.data('ajax-uri') };

                this.makeRequest(requestInfo, $orderToOpen);
            }
        }
    },

    /**
     * Pushes data to dataLayer on first click step of coupon/sample.
     * @param {string} sampleCouponHeading - Sample/coupon heding
     */
    initGaEventsOnClick: function () {
        $('.signpost-basic__call-to-action .btn').on('click', function () {
            var $button = $(this);
            var sampleTitle = $button
                .parents('.sample-coupon')
                .find('.signpost-basic__headline h2')
                .text();

            window.dataLayer.push({
                event: 'gaEvent',
                eventTrigger: 'sampleRequest',
                eventCategory: 'Sample request',
                eventAction: 'OrderForm',
                eventLabel: sampleTitle
            });
        });
    },

    /**
     * If query variable is set / redirected back to coupon/sample page from azure.
     */
    initUrlQueryListener: function () {
        var id = this.getQueryVariable('cta') || false;
        if (id) {
            var $button = $('#' + id).find('.signpost-basic__call-to-action .btn');
            var $sample = $button.closest('.sample-coupon');
            var $order = $('#' + id).find('.sample-coupon__order');

            var requestInfo = { method: 'get', uri: $sample.data('ajax-uri') };

            this.makeRequest(requestInfo, $order);
        }
    },

    /**
     * Helper function to get a querystring value from the URL.
     * @param {string} variable - Querystring key to get the value from.
     * @returns {string|boolean}
     */
    getQueryVariable: function (variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var index = 0; index < vars.length; index++) {
            var pair = vars[index].split('=');
            if (pair[0] === variable) {
                return pair[1];
            }
        }

        return false;
    }
};
